import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();
  //state data
  const [isDashboard, setIsDashboard] = useState(false);
  const [isUsers, setIsUsers] = useState(false);
  const [isChampionships, setIsChampionships] = useState(false);
  const [isQuestions, setIsQuestions] = useState(false);
  const [isCategory, setIsCategory] = useState(false);
  const [isRooms, setIsRooms] = useState(false);
  const [isContentReview, setIsContentReview] = useState(false);
  const [isNotifications, setIsNotifications] = useState(false);
  const [isStore, setIsStore] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [isApps, setIsApps] = useState(false);
  const [isSubmissions, setIsSubmissions] = useState(false);
  const [isAuth, setIsAuth] = useState(false);
  const [isPages, setIsPages] = useState(false);
  const [isBaseUi, setIsBaseUi] = useState(false);
  const [isAdvanceUi, setIsAdvanceUi] = useState(false);
  const [isForms, setIsForms] = useState(false);
  const [isTables, setIsTables] = useState(false);
  const [isCharts, setIsCharts] = useState(false);
  const [isIcons, setIsIcons] = useState(false);
  const [isMaps, setIsMaps] = useState(false);
  const [isMultiLevel, setIsMultiLevel] = useState(false);

  // Apps

  const [isEcommerce, setIsEcommerce] = useState(false);
  const [isContactUs, setIsContactUs] = useState(false);
  const [isJobApplications, setIsJobApplications] = useState(false);

  // Pages
  const [isProfile, setIsProfile] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  const authUser = JSON.parse(sessionStorage.getItem("authUser"));
  const role = authUser?.data?.role;

  // useEffect(() => {
  //   if (role === "admin") {
  //     history("/posts");
  //   } else if (role === "manager") {
  //     history("/dashboard");
  //   }
  // }, [role, history]);
  const managerOnly = ["dashboard", "submissions", "Ads"];

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Users") {
      setIsUsers(false);
    }
    if (iscurrentState !== "Championships") {
      setIsChampionships(false);
    }
    if (iscurrentState !== "Questions") {
      setIsQuestions(false);
    }
    if (iscurrentState !== "Rooms") {
      setIsRooms(false);
    }
    if (iscurrentState !== "ContentReview") {
      setIsContentReview(false);
    }
    if (iscurrentState !== "Notifications") {
      setIsNotifications(false);
    }
    if (iscurrentState !== "Store") {
      setIsStore(false);
    }
    if (iscurrentState !== "Payment") {
      setIsPayment(false);
    }
    if (iscurrentState !== "Setting") {
      setIsSetting(false);
    }
    if (iscurrentState !== "Apps") {
      setIsApps(false);
    }
    if (iscurrentState !== "Submissions") {
      setIsSubmissions(false);
    }
    if (iscurrentState !== "Auth") {
      setIsAuth(false);
    }
    if (iscurrentState !== "Pages") {
      setIsPages(false);
    }
    if (iscurrentState !== "BaseUi") {
      setIsBaseUi(false);
    }
    if (iscurrentState !== "AdvanceUi") {
      setIsAdvanceUi(false);
    }
    if (iscurrentState !== "Forms") {
      setIsForms(false);
    }
    if (iscurrentState !== "Tables") {
      setIsTables(false);
    }
    if (iscurrentState !== "Charts") {
      setIsCharts(false);
    }
    if (iscurrentState !== "Icons") {
      setIsIcons(false);
    }
    if (iscurrentState !== "Maps") {
      setIsMaps(false);
    }
    if (iscurrentState !== "MuliLevel") {
      setIsMultiLevel(false);
    }
    if (iscurrentState === "Widgets") {
      history("/widgets");
      document.body.classList.add("twocolumn-panel");
    }
    // if (iscurrentState !== "Landing") {
    //   setIsLanding(false);
    // }
  }, [
    history,
    isDashboard,
    isUsers,
    isChampionships,
    isQuestions,
    isCategory,
    isRooms,
    isContentReview,
    isNotifications,
    isStore,
    isPayment,
    isSetting,
    isApps,
    iscurrentState,
    isSubmissions,
    isAuth,
    isPages,
    isBaseUi,
    isAdvanceUi,
    isForms,
    isTables,
    isCharts,
    isIcons,
    isMaps,
    isMultiLevel,
  ]);

  const menuItems = [
    {
      id: "dashboard",
      label: "الرئيسية",
      icon: "ri-dashboard-2-line",
      link: "/dashboard",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    {
      id: "users",
      label: "المستخدمين",
      icon: "ri-group-line",
      link: "/users",
      click: function (e) {
        e.preventDefault();
        setIsUsers(!isUsers);
        setIscurrentState("Users");
        updateIconSidebar(e);
      },
      stateVariables: isUsers,
    },
    {
      id: "championships",
      label: "البطولات",
      icon: "ri-trophy-line",
      link: "/championships",
      click: function (e) {
        e.preventDefault();
        setIsChampionships(!isChampionships);
        setIscurrentState("Championships");
        updateIconSidebar(e);
      },
      stateVariables: isChampionships,
    },
    {
      id: "questions",
      label: "الأسئلة",
      icon: "ri-question-line",
      link: "/questions",
      click: function (e) {
        e.preventDefault();
        setIsQuestions(!isQuestions);
        setIscurrentState("Questions");
        updateIconSidebar(e);
      },
      stateVariables: isQuestions,
    },
    {
      id: "category",
      label: "الغرف",
      icon: "ri-folder-line",
      link: "/category",
      click: function (e) {
        e.preventDefault();
        setIsCategory(!isCategory);
        setIscurrentState("Category");
        updateIconSidebar(e);
      },
      stateVariables: isCategory,
    },
    {
      id: "rooms",
      label: "مسابقات الغرف",
      icon: "ri-door-open-line",
      link: "/rooms",
      click: function (e) {
        e.preventDefault();
        setIsRooms(!isRooms);
        setIscurrentState("Rooms");
        updateIconSidebar(e);
      },
      stateVariables: isRooms,
    },
    // {
    //   id: "content_review",
    //   label: "مراجعة المحتوى",
    //   icon: "ri-shield-check-line",
    //   link: "/content_review",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsContentReview(!isContentReview);
    //     setIscurrentState("ContentReview");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isContentReview,
    // },
    // {
    //   id: "notifications",
    //   label: "الإشعارات",
    //   icon: "ri-notification-3-line",
    //   link: "/notifications",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsNotifications(!isNotifications);
    //     setIscurrentState("Notifications");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isNotifications,
    // },
    {
      id: "store",
      label: "المتجر",
      icon: "ri-store-2-line",
      link: "/store",
      click: function (e) {
        e.preventDefault();
        setIsStore(!isStore);
        setIscurrentState("Store");
        updateIconSidebar(e);
      },
      stateVariables: isStore,
    },
    // {
    //   id: "payment",
    //   label: "المدفوعات",
    //   icon: "ri-wallet-3-line",
    //   link: "/payment",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsPayment(!isPayment);
    //     setIscurrentState("Payment");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isPayment,
    // },
    {
      id: "setting",
      label: "الإعدادات",
      icon: "ri-settings-3-line",
      link: "/setting",
      click: function (e) {
        e.preventDefault();
        setIsSetting(!isSetting);
        setIscurrentState("Setting");
        updateIconSidebar(e);
      },
      stateVariables: isSetting,
    },
  ];

  const filteredMenu = menuItems.filter((item) => {
    if (role === "admin") {
      return !managerOnly.includes(item.id);
    }
    return true;
  });

  return <React.Fragment>{filteredMenu}</React.Fragment>;
};
export default Navdata;
